import React, {useState} from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import {FRAGMENTS_FILE} from '../utils/graphqlFragments'
import {isPublishedToAGS} from '../utils/isPublishedToAGS'
import { useQuery } from '@apollo/react-hooks'
import { get } from 'lodash'

const reload = () => window.location.reload()

const MF_QUERY_UNZIP = gql`
  mutation handleMFActions($input: ManageFileInput!) {
    handleMFActions(input: $input) {
      invokeResult
      error
    }
  }
`
const MF_QUERY_PUBLISH_AGOL = gql`
  mutation handleMFActions($input: ManageFileInput!) {
    handleMFActions(input: $input) {
      invokeResult
      error
    }
  }
`

const MF_QUERY_UNPUBLISH_AGOL = gql`
  mutation handleMFActions($input: ManageFileInput!) {
    handleMFActions(input: $input) {
      invokeResult
      error
    }
  }
`

const MF_QUERY_MIGRATE = gql`
  ${FRAGMENTS_FILE}
  mutation handleMFActions($input: ManageFileInput!) {
    handleMFActions(input: $input) {
      percent
      itemFile{
        ... fileFields
      }
      invokeResult
      error
    }
  }
`

const GET_DISTRIBUTION_LINKS = gql`
  query item($id: ID!){
    item(id: $id){
        facets {
          facetName
        }
        distributionLinks {
            uri
        }
	}
  }
`


const ACTION_MIGRATE = 'Migrate'
const ACTION_UNZIP = 'Unzip'
const ACTION_PUBLISH_AGOL = 'Publish to ArcGIS Online'
const ACTION_UNPUBLISH_AGOL = 'Unpublish from ArcGIS Online'
const ACTION_UNZIP_FIELD_NAME = 'processStatus'
const ACTION_MIGRATE_FIELD_NAME = 'movedToS3'
const ACTION_PUBLISH_AGOL_FIELD_NAME = 'processStatus'
const ACTION_UNPUBLISH_AGOL_FIELD_NAME = 'processStatus'

export default function MFActionsModal(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)

  const handleClose = () => {
    props.onHide()
    reload()
  }

  const { loading: loading_distLinks, error: error_distLinks, data: data_distLinks } = useQuery(GET_DISTRIBUTION_LINKS, {
    variables: { id: props.itemId },
    fetchPolicy: 'no-cache'
  })

  //console.log(loading_distLinks)
  //console.log(error_distLinks)
  //console.log("data_distLinks")
  //console.log(data_distLinks)

  const distributionLinks = get(data_distLinks, 'item.distributionLinks', null)
  //console.log("distributionlinks")
  //console.log(distributionLinks)

  const item_data = get(data_distLinks, 'item', null)
  //console.log("item_data")
  //console.log(item_data)

  const facets = get(data_distLinks, 'item.facets', null)
  //console.log("facets")
  //console.log(facets)

  const isPublishedAGS = isPublishedToAGS(distributionLinks, props.row.name)
  //console.log("isPublishedAGS")
  //console.log(isPublishedAGS)

  var migrateTemp = null;

  if(isPublishedAGS && props.row.name.endsWith(".sd")){
      migrateTemp = {
        mutation: MF_QUERY_MIGRATE,
        actionFileField: ACTION_MIGRATE_FIELD_NAME,
        actionHead:'Migrate File',
        actionButton:ACTION_MIGRATE,
        actionBody:<div><h3>You are about to migrate a file to S3: {props.row.name}</h3>
      <br/>
      <p>Your file will be copied to a private bucket. The file will need to be migrated in ScienceBase internal storage to enable additional actions. The .sd file will be updated to be compatible for publishing to ArcGIS Online, and the storage path in the item JSON will be updated. Any spatial services associated with this file in our on-premise ArcGIS Server instance will be stopped. A new spatial service will be started on the updated compatible .sd file in ArcGIS Online. Proceed?</p></div>}
  }
  else {
    migrateTemp = {
      mutation: MF_QUERY_MIGRATE,
      actionFileField: ACTION_MIGRATE_FIELD_NAME,
      actionHead:'Migrate File',
      actionButton:ACTION_MIGRATE,
      actionBody:<div><h3>You are about to migrate a file to S3: {props.row.name}</h3>
        <br/>
        <p>Your file will be copied to a private bucket. The file will need to be migrated in ScienceBase internal storage to enable additional actions. The file will not be changed, however, the storage path in the item JSON will be updated. Proceed?</p></div>}
  }

  const unzipTemp= {
    mutation: MF_QUERY_UNZIP,
    actionFileField: ACTION_UNZIP_FIELD_NAME,
    actionHead:'Unzip File',actionButton:ACTION_UNZIP,
    actionBody:<div><h3>You are about to unzip file: {props.row.name}</h3>
      <br/>
      <p>Your file will be unzipped to the same bucket. Please note that this may take some time to complete.</p></div>}

  const agolTemp= {
    mutation: MF_QUERY_PUBLISH_AGOL,
    actionFileField: ACTION_PUBLISH_AGOL_FIELD_NAME,
    actionHead:'Publish Service Definition to USGS ArcGIS Online',actionButton:ACTION_PUBLISH_AGOL,
    actionBody:<div><h3>You are about to publish the following .sd file to the USGS ArcGIS Online (AGOL) space: {props.row.name}</h3>
      <br/>
      <p>The process of starting a map service from an ESRI .sd file may take several minutes. You will receive an email (sent to the email associated with your ScienceBase user account) indicating the status of the publishing job when it is complete. Successful service generation will also be reflected in the ScienceBase item at that time (I.e., AGOL map service URIs will be added to the item JSON and show page).</p>
      <br/>
      <p>Before proceeding, please confirm that the content being published does <b>not</b> contain Personally Identifiable Information (PII) or Controlled Unclassified Information (CUI). This type of content is prohibited from being hosted in the USGS ArcGIS Online instance.</p>
      <br/>
      <p>Please note that to be compatible with the USGS AGOL space, .sd files need to be made while a user is signed into an organizational account. Additionally, .sd filenames must be globally unique with the USGS AGOL space. The name must be established internally in the file when creating the .sd simply re-naming a file on disk will not resolve naming conflicts.</p></div>}

  const agolUnpublishTemp= {
    mutation: MF_QUERY_UNPUBLISH_AGOL,
    actionFileField: ACTION_UNPUBLISH_AGOL_FIELD_NAME,
    actionHead:'Unpublish Service from USGS ArcGIS Online',actionButton:ACTION_UNPUBLISH_AGOL,
    actionBody:<div><h3>You are about to unpublish the following .sd file from the USGS ArcGIS Online (AGOL) space: {props.row.name}</h3>
      <br/>
      <p>The process of stopping a map service from an ESRI .sd file may take a few minutes. You will receive an email (sent to the email associated with your ScienceBase user account) indicating the status of the unpublishing job when it is complete. Successful service unpublishing will also be reflected in the ScienceBase item at that time (I.e., AGOL map service URIs will be removed from the item JSON and show page).</p></div>}

  function getActionTemp() {
    switch (props.action) {
    case ACTION_UNZIP: return unzipTemp
    case ACTION_MIGRATE: return migrateTemp
    case ACTION_PUBLISH_AGOL: return agolTemp
    case ACTION_UNPUBLISH_AGOL: return agolUnpublishTemp

    default: return unzipTemp
    }}
  const templateCode = getActionTemp()

  const [ takeAction ] = useMutation(
    templateCode.mutation,
    {
      variables: {
        input: {
          itemId: props.itemId,
          filename: props.row.name,
          action:props.action,
          pathOnDisk:props.row.pathOnDisk
        }
      },
      onCompleted: ( { handleMFActions}) => {
        if(props.action === ACTION_MIGRATE){
          console.log("handleMFActions.itemFile")
          console.log(handleMFActions.itemFile)
        }
        if(props.action === ACTION_UNZIP){
          props.row[templateCode.actionFileField] =handleMFActions.invokeResult
          //props.resetRow(props.row)
        }
        if(props.action === ACTION_PUBLISH_AGOL){
          props.row[templateCode.actionFileField] =handleMFActions.invokeResult
          console.log(handleMFActions.invokeResult)
          //props.resetRow(props.row)
        }
        if(props.action === ACTION_UNPUBLISH_AGOL){
          props.row[templateCode.actionFileField] =handleMFActions.invokeResult
          console.log(handleMFActions.invokeResult)
          //props.resetRow(props.row)
        }
        setIsLoading(false)
        setIsComplete(true)
      }

    }
  )

  return (
    <Modal {...props} size="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{templateCode.actionHead}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            e.preventDefault()
            setIsLoading(true)
            takeAction()
          }}
        >
          {templateCode.actionBody}
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Close</Button>
            {isComplete?'':<Button variant="primary" type="submit">{isLoading?<span ><FontAwesomeIcon icon={faSpinner} pulse/></span>:''}&nbsp;{templateCode.actionButton}</Button>}
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

MFActionsModal.propTypes = {
  resetRow: PropTypes.func,
  resetfiles: PropTypes.func,
  rowindex: PropTypes.func,
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    pathOnDisk: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
  action: PropTypes.string
}
